import uni from "../styles/univesal.module.css";
import { header } from "./common";
import type {DocumentCallback} from "@innovatrics/dot-document-auto-capture";
import DocumentCamera from "../components/DocumentCamera";
import DocumentUi from "../components/DocumentUi";
import { LangIds, Languages, getLang } from "../langs/langs";

interface Props {
  lang: Languages;
  headerNum: String
  onDocument: DocumentCallback;
  onError: (error: Error) => void;
}

function DocumentScanBack({lang, headerNum, onDocument, onError}: Props) {

  const onDocumentCallback: DocumentCallback = async (imageData, content) => {
    onDocument(imageData, content);
  };

  return (
    <>
    <div className={uni.container}>
      {header(getLang(LangIds.SCANID_Capture, lang), headerNum)}
      <div className={uni.innerCameraContainer}>
        <span className={uni.cameraText}>{getLang(LangIds.SCANID_Back, lang)}</span>
          <DocumentCamera
            cameraFacing="environment"
            onPhotoTaken={onDocumentCallback}
            onError={onError}
          />
          <DocumentUi 
            placeholder={"passport-solid-back"}
            instructions={{ candidate_selection: getLang(LangIds.SCANID_candidate_selection, lang), document_centering: getLang(LangIds.SCANID_document_centering, lang), document_not_present: getLang(LangIds.SCANID_document_not_present, lang), document_too_far: getLang(LangIds.SCANID_document_too_far, lang), sharpness_too_low: getLang(LangIds.SCANID_sharpness_too_low, lang), brightness_too_low: getLang(LangIds.SCANID_brightness_too_low, lang), brightness_too_high: getLang(LangIds.SCANID_brightness_too_high, lang), hotspots_present: getLang(LangIds.SCANID_hotspots_present, lang) }}
            appStateInstructions={{ loading: { text: getLang(LangIds.SCANID_loading, lang), visible: true }, waiting: { text: getLang(LangIds.SCANID_waiting, lang), visible: true } }}
            theme={{ colors: { placeholderColor: "white" } }}
            backdropColor="white"
            showDetectionLayer showCameraButtons />
        </div>
      </div>
    </>
  );
}

export default DocumentScanBack;
